<template>
  <div class="announcement-warp">
    <Applition v-if="link==='1'" :props-id="link" />
    <Resoure v-if="link==='2'" :props-id="link" />
    <Teacher v-if="link==='3'" :props-id="link" />
  </div>
</template>
<script>
import Applition from './searchResultDetail/applition';
import Resoure from './searchResultDetail/resoure';
import Teacher from './searchResultDetail/teacher';
export default {
  name: 'SearchResultDetail',
  components: {
    Applition,
    Resoure,
    Teacher
  },
  data: () => {
    return {
      link: ''
    };
  },
  computed: {
  },
  watch: {
    $route: {
      handler: function(route) {
        this.link = route.params.id;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
};
</script>
